module.exports = __webpack_public_path__ + "static/media/keratometry-ref.7f448937.png";